import type { DashboardCard } from "../api/types.ts"

export type DashboardGroupId = "urgent" | "mine" | "status"
export type DashboardGroup = { id: DashboardGroupId; cards: DashboardCard[] }

/** 카드 키 → 구역. 여기 없는 키는 "내 차례"로 간다 — 서버에 카드가 늘어도 화면이 깨지지 않게. */
const GROUP_OF: Record<string, DashboardGroupId> = {
  overdue: "urgent",
  review_requested: "urgent",
  arrived_today: "status",
}

const ORDER: DashboardGroupId[] = ["urgent", "mine", "status"]

/**
 * 서버가 준 카드를 급한 순으로 묶는다.
 *
 * 카드의 `query` 는 손대지 않고 그대로 넘긴다 — 화면이 조건을 다시 만들면
 * 카드 숫자와 목록 건수가 어긋난다.
 */
export function groupDashboardCards(cards: DashboardCard[]): DashboardGroup[] {
  return ORDER.map((id) => {
    const mine = cards.filter((card) => (GROUP_OF[card.key] ?? "mine") === id)
    // 0 건은 뒤로 보내되 숨기지는 않는다. 0 이라는 것도 정보다.
    const sorted = [
      ...mine.filter((card) => card.count > 0),
      ...mine.filter((card) => card.count === 0),
    ]
    return { id, cards: sorted }
  }).filter((group) => group.cards.length > 0)
}
